// extracted by mini-css-extract-plugin
export default {"grid":"EmptyBeneficiaryFilters_grid__LNDHI"};